<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.services") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn :to="{ name: 'create_service' }" class="primary">
        <span>{{ $t("button.create") }}</span>
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="services"
      class="table-row"
      dialogWidth="500"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          <v-avatar size="40">
            <v-img
              @click="$refs.table_ref.handleImagePreview(item.main_image)"
              class="hover-pointer"
              aspect-ratio="1"
              :src="
                item.main_image
                  ? item.main_image.path
                  : '@/assets/imgs/user.jpg'
              "
            ></v-img>
          </v-avatar>
        </td>
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-sm-center">{{ item.priority }}</td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="services"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">{{ item.description | truncate }}</td>
        <td class="text-sm-center">
          <router-link
            :to="{ name: 'edit_service', params: { slug: item.slug } }"
          >
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </router-link>

          <v-icon
            :title="$t('icon.delete')"
            @click="handleDelete(item, index)"
            small
            >mdi-delete</v-icon
          >
        </td>
      </template>
    </wrapping-table>
  </main>
</template>
<script>
export default {
  name: "Services",
  data() {
    return {
      headers: ["photo", "name", "priority", "visibility", "desc", "actions"]
    };
  },
  methods: {
    handleDelete({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    }
  }
};
</script>
